module.exports = __webpack_public_path__ + "edc0d050e2d27e13c7cc532b84268d57.pdf";